module.exports = __webpack_public_path__ + "static/media/stonecon-limited.647701ce.png";